import React, { Component } from 'react'
import { connect } from 'react-redux'

import * as R from 'ramda'
import Moment from 'moment'

import TextField from 'material-ui/TextField'

import dataActions from 'actions/dataActions'
import { doc, dirtyRead } from 'selectors/common'
import { transactionEx } from 'selectors/transactions'

let select = dirtyRead(
	(state, props) => ({
		transaction: transactionEx(state, props.objectID)
	})
)

export class TransactionMemo extends Component{
	render(){
		let { props } = this
		return(
			<div>
				<TextField
					hintStyle={{fontStyle: "italic", fontSize: "14px"}}
					key ={props.transaction.memo}
					floatingLabelText= {
						props.transaction.type=="transaction/bill"
							?"Bill memo"
							:props.transaction.type=="transaction/invoice"
								?"Invoice memo"
								:"Payment memo"
					}
					floatingLabelStyle={{
						fontWeight: "100",
						fontSize: "14px"
					}}
					underlineStyle={{
						borderBottom: "0px solid #b0bec4"
					}}
					underlineDisabledStyle={{borderBottom: "0px solid"}}
					multiLine = {false}
					fullWidth={true}
					disabled={true}
					style={{
						marginTop:"-15px"
						, color: "#000"
					}}
					inputStyle ={{color: "#000"}}
					defaultValue={props.transaction.memo ? props.transaction.memo : ''}
					onBlur={(evt) =>{
						props.STAGE({
							_id: props.objectID
							, memo: evt.target.value
						})

					}}
				/>
			</div>
		)
	}
}

export default connect(select, dataActions)(TransactionMemo)



// WEBPACK FOOTER //
// ./src/routes/landlord/transactionForm/TransactionMemo.js